import { AccordionDetails, Box, Grid, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  NEED_TO_CANCEL_APPOINTMENT,
  NEED_TO_RESCHEDULE,
  TICKET_DETAILS,
} from "../../../../Constants/constants";
import { setIsOrder } from "../../../../Redux/Slices/OrderDetailsSlice";
import { getFlags, splitDataBasedOnTitle } from "../../../../Services/helper";
import {
  AccountDivider,
  HeadingSmall,
  HeadingTypography,
  StyledA,
  StyledElement,
  StyledGridItem,
  VerticalDivider,
} from "../../../../Styles/GlobalStyles";

export const ManageTicket = (props: any) => {
  const { data, title, showRescheduleButton } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { orderDetails } = useSelector((state: any) => state.customerInfoDetails);
  const { troubleTicketDetails } = useSelector((state: any) => state.troubleTicketDetails);
  const envFlags = useSelector((state: any) => state?.userInfo?.envFlags);
  const SHOW_WHERE_IS_MY_TECH = getFlags("enable_where_is_my_tech", envFlags);

  const handleNavigate = () => {
    navigate("/home/reschedule-appointment");
    title === orderDetails?.headerTitle ? dispatch(setIsOrder(true)) : dispatch(setIsOrder(false));
  };

  const [group1, group2] = splitDataBasedOnTitle(data);
  const hasGroup2Content = Array.isArray(group2) && group2.length > 0;

  const renderRow = ({ leftItem, rightItem }: { leftItem: any; rightItem: any }) => {
    const hasLeft = !!leftItem?.value;
    const hasRight = !!rightItem?.value;

    if (!hasLeft && !hasRight) return null;
    const leftContent = hasLeft ? leftItem : hasRight ? rightItem : null;
    const rightContent = hasLeft && hasRight ? rightItem : null;

    const renderItem = (item: any) => (
      <AccordionDetails sx={{ flex: 1 }}>
        <HeadingTypography>
          {item?.name} {item?.description && item?.value}
        </HeadingTypography>
        <HeadingSmall>{item?.description ? item?.description : item?.value}</HeadingSmall>
      </AccordionDetails>
    );

    return (
      <>
        <Grid container spacing={2} mx={1} alignItems="stretch">
          <StyledGridItem item xs={6}>
            {leftContent && renderItem(leftContent)}
            {rightContent && <VerticalDivider orientation="vertical" />}
          </StyledGridItem>

          {rightContent && (
            <StyledGridItem item xs={6}>
              {renderItem(rightContent)}
            </StyledGridItem>
          )}
        </Grid>

        <Box ml={2} sx={{ display: "flex", justifyContent: "left", width: "100%" }}>
          <AccountDivider sx={{ width: "94%" }} />
        </Box>
      </>
    );
  };

  const showCancelTicketButton = title === TICKET_DETAILS;

  return (
    <div>
      {Array.isArray(group1) &&
        group1.length > 0 &&
        group1.map((item: any, index: number) => (
          <Grid container mx={1} my={1} direction="column" key={index}>
            {item?.value && (
              <AccordionDetails>
                <HeadingTypography>
                  {item?.name} {item?.description && item?.value}
                </HeadingTypography>
                <HeadingSmall>{item?.description ? item?.description : item?.value}</HeadingSmall>
              </AccordionDetails>
            )}
            <AccountDivider />
          </Grid>
        ))}
      {hasGroup2Content && (
        <Grid container spacing={2} direction="column" my={1}>
          {SHOW_WHERE_IS_MY_TECH ? (
            <>
              {renderRow({ leftItem: group2[0] || null, rightItem: group2[1] || null })}
              {renderRow({ leftItem: group2[2] || null, rightItem: group2[3] || null })}
              {renderRow({ leftItem: group2[4] || null, rightItem: group2[5] || null })}
            </>
          ) : (
            renderRow({ leftItem: group2[0] || null, rightItem: group2[1] || null })
          )}
        </Grid>
      )}

      {showRescheduleButton && (
        <>
          <AccordionDetails sx={{ display: "block" }}>
            <StyledElement onClick={handleNavigate} fontWeight={600} ml={1}>
              RESCHEDULE APPOINTMENT
            </StyledElement>
          </AccordionDetails>
          <Box ml={1} sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
            <AccountDivider sx={{ width: "96%" }} />
          </Box>
        </>
      )}

      {showCancelTicketButton && (
        <AccordionDetails sx={{ display: "block" }}>
          <StyledElement
            onClick={() => navigate("/home/cancel-appointment")}
            ml={1}
            fontWeight={600}>
            CANCEL TICKET
          </StyledElement>
        </AccordionDetails>
      )}

      {title === orderDetails?.headerTitle && (
        <AccordionDetails sx={{ display: "block" }}>
          <Typography ml={1}>
            {title === orderDetails?.headerTitle ? NEED_TO_RESCHEDULE : NEED_TO_CANCEL_APPOINTMENT}
            &nbsp;Call&nbsp;
            <StyledA href="tel:1-866-699-4759">1.866.MYZIPLY</StyledA>
          </Typography>
        </AccordionDetails>
      )}
    </div>
  );
};
